import './styles/blogPage.scss';

import { PageTitle, SingleBlog } from '../components/Primitives';
import React, { useEffect, useState } from 'react';

import { Breadcrumb } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useWindowSize';

export const query = graphql`
    query {
        articles: allProductsJson(
            filter: { category: { eq: "/Englander/CMS/Blog/" } }
        ) {
            nodes {
                category
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                images {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    ...productsFieldsImagesFragment
                }
                attributes {
                    content_short {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    content {
                        group
                        values {
                            fr_CA
                            en_CA
                            en_US
                        }
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    content_wysiwyg {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        metadata: allProductsJson(filter: { code: { eq: "englander_blogs" } }) {
            nodes {
                code
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

export default function Article({ data, pageContext }) {
    const article = data.articles.nodes?.find(
        (e) => e?.code === pageContext?.code
    );
    const relatedArticles = data.articles.nodes?.filter(
        (e) => e?.code !== pageContext?.code
    );
    const { currentLocale } = usePageLocalization();
    const [size, isSmall, isMedium] = useWindowSize();
    let isMarkdown = false;
    let articleContent;
    if (article?.attributes?.content_wysiwyg?.values?.[0]?.[currentLocale]) {
        articleContent =
            article?.attributes?.content_wysiwyg?.values?.[0]?.[currentLocale];
    } else {
        articleContent =
            article?.attributes?.content?.valuesMarkdownRemark?.[0]?.[
                currentLocale
            ];
        isMarkdown = true;
    }

    let count = -1;
    const { t } = useTranslation('pages');

    if (articleContent) {
        articleContent = articleContent.replace(
            /(!\[.*?\]\()(.+?)(\))/g,
            function (whole, a, b, c) {
                count++;
                return article?.fields?.images
                    ? a +
                          article?.fields?.images?.[count]?.childImageSharp
                              ?.gatsbyImageData?.images?.fallback?.src +
                          c
                    : '';
            }
        );
    }
    const metadataAttributes = data?.metadata?.nodes?.[0]?.attributes;
    const singleBlogMetaAttributes = article?.attributes;
    const title: string = article?.title?.[currentLocale];
    const [adaptatedTitle, setAdaptedTitle] = useState(title);

    useEffect(() => {
        if (isSmall) {
            setAdaptedTitle(`${title.slice(0, 20).trimEnd()}...`);
        } else if (size?.width <= 500) {
            setAdaptedTitle(`${title.slice(0, 30).trimEnd()}...`);
        } else if (isMedium) {
            setAdaptedTitle(`${title.slice(0, 40).trimEnd()}...`);
        } else {
            setAdaptedTitle(title);
        }
    }, [isMedium, isSmall, size, title]);
    return (
        <Layout>
            <SEO
                title={
                    singleBlogMetaAttributes?.meta_title?.values?.[0][
                        currentLocale
                    ] ||
                    metadataAttributes.meta_title?.values?.[0][currentLocale]
                }
                description={
                    singleBlogMetaAttributes?.meta_description?.values?.[0][
                        currentLocale
                    ] ||
                    metadataAttributes.meta_description?.values?.[0][
                        currentLocale
                    ]
                }
                isDescriptionCurrentLocale={true}
            />
            <div className='blog-page-header'></div>
            <div className='container blogPage'>
                <Breadcrumb
                    elements={[
                        { link: '/', name: t('layout:appliance.home') },
                        {
                            link: '/blogArchives',
                            name: t('layout:menu-titles.blog'),
                        },
                        { link: '', name: adaptatedTitle },
                    ]}
                />
                <div className='row article'>
                    <div id='primary'>
                        <div className='article-contain'>
                            <PageTitle title={title} />
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: articleContent,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className='related-blogs'>
                    <PageTitle
                        title={t('pages:blogs.related-articles')}
                        notHeader
                    />
                    <div className='blog-section'>
                        {relatedArticles.slice(0, 3)?.map((blog, index) => {
                            return (
                                <SingleBlog
                                    blog={blog}
                                    key={`blog-archives-${index}-related`}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        </Layout>
    );
}
